import { useEffect } from "react";
import { Divider, Grid } from "@material-ui/core";
import { Loading } from "components/shared";
import { Main } from "components/pages";
import {
  DashInfoCard,
  DashInfoCardTotal,
  Chart,
} from "components";
import { useSet } from "hooks";
import { ISetModulocker } from "config/interfaces";
import { useSession } from "context/SessionContext";

import { getSubDomain, verAccessType } from "components/shared/getUrl";

export default function Dashboard() {
  verAccessType(getSubDomain) && window.location.replace(`/admin/#/correios/`);
  
  const { IDMCM } = useSession();

  const { getSetInformations, setModulocker, charts, loadingSets } = useSet();
  const { info: infos } = setModulocker;

  // FILL INSTALLATIONS OPTIONS
  // ------------------------------------------------------
  // useEffect(() => {
  //   (async () => {
  //     const newInstallations = installationsSelectOptions?.map(
  //       (installation) => {
  //         return {
  //           label: installation.label,
  //           value: installation.label,
  //         };
  //       }
  //     );

  //     if (newInstallations.length > 0) {
  //       setData((state: any) => {
  //         const selectedInstallation =
  //           IDSITE.length > 0 ? IDSITE : newInstallations[0].value;
  //         setIDSITE(selectedInstallation);

  //         return {
  //           ...state,
  //           installations: newInstallations,
  //           installation: selectedInstallation,
  //         };
  //       });
  //     }
  //   })();

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [installationsSelectOptions]);

  // WHEN INSTALLATIONS CHANGING
  // ------------------------------------------------------
  // useEffect(() => {
  //   (async () => {
  //     if (data.installation) {
  //       await getAllSetsShort({ IDSITE: data.installation });
  //     }
  //   })();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [data.installation]);

  // WHEN WE HAVE NEW SETS
  // ------------------------------------------------------
  // useEffect(() => {
  //   const isSelectedIDMCM = setsShort.some(
  //     (set) => String(set.IDMCM) === IDMCM
  //   );

  //   if (setsShort.length > 0) {
  //     const myOptions = setsShort.map((set) => {
  //       return {
  //         label: set.DSMCM,
  //         value: String(set.IDMCM),
  //       };
  //     });

  //     return setData((state: any) => {
  //       const selectedSet = isSelectedIDMCM ? IDMCM : myOptions[0].value;
  //       setIDMCM(selectedSet);

  //       return {
  //         ...state,
  //         setsOptions: myOptions,
  //         set: isSelectedIDMCM ? IDMCM : String(selectedSet),
  //       };
  //     });
  //   }

  //   setIDMCM("");
  //   setData((state: any) => {
  //     return {
  //       ...state,
  //       setsOptions: [],
  //       set: "",
  //     };
  //   });
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [setsShort]);

  // WHEN SET CHANGING
  // ------------------------------------------------------
  useEffect(() => {
    (async () => {
      if (IDMCM) {
        await getSetInformations(IDMCM);
      }
    })();
    //
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [IDMCM]);

  const isCardClickable = (name: string) => {
    return (
      name === "total" ||
      name === "BoxAvailable" ||
      name === "BoxWaitingPickup" ||
      name === "BoxExpired" ||
      name === "BoxReserved" ||
      name === "BoxTampered"
    );
  };

  const isHighLightCard = (name: string) => {
    return name === "total";
  };

  const isCardToDashboard = (name: string) => {
    return (
      name === "total" || name === "BoxAvailable" || name === "BoxWaitingPickup"
      // name === "BoxExpired"
    );
  };

  const isCardToOpenDoors = (name: string) => {
    return name === "BoxOpenedAfterDropoff" || name === "BoxOpenedAfterPickup";
  };

  const getCardTitle = (name: string) => {
    switch (name) {
      case "total":
        return `Total de Boxes`;
      case "BoxOpenedAfterDropoff":
        return `Após entrega`;
      case "BoxOpenedAfterPickup":
        return `Após retirada`;
      case "BoxAvailable":
        return `Disponível`;
      case "BoxWaitingPickup":
        return `Aguardando Retirada`;
      case "BoxTransactionFinished":
        return `Retiradas`;
      case "BoxExpired":
        return `Prazo de Retirada Vencido`;
      case "BoxTampered":
        return `Box Violados`;
      default:
        break;
    }
  };

  let openDoorsCard: any[] = [];
  // console.log(infos);
  const infoCards = infos?.map((info: ISetModulocker.BoxInfo, index) => {
    const infoBySize = {
      p: info.QtdStatusBox.p,
      m: info.QtdStatusBox.m,
      g: info.QtdStatusBox.g,
      gg: info.QtdStatusBox.gg,
    };

    if (isCardToDashboard(info.DescrStatus)) {
      if (info.DescrStatus === "total") {
        return (
          <DashInfoCardTotal
            key={index}
            isClickable={isCardClickable(info.DescrStatus)}
            title="Total de Armários / Boxes"
            value={[setModulocker.modulocker, info.QtdStatusBox.count]}
            info={infoBySize}
          />
        );
      }

      // if (info.DescrStatus === "BoxTampered") {
      //   return (
      //     <DashInfoCardBreak
      //       key={index}
      //       isClickable={isCardClickable(info.DescrStatus)}
      //       title={getCardTitle(info.DescrStatus)}
      //       name={info.DescrStatus}
      //       value={info.QtdStatusBox.count > 0 ? info.QtdStatusBox.count : "-"}
      //       fontSizeTitle={
      //         isHighLightCard(info.DescrStatus) ? "1.6rem" : "1.4rem"
      //       }
      //       fontWeightTitle={isHighLightCard(info.DescrStatus) ? 600 : 400}
      //       fontSizeValue={
      //         isHighLightCard(info.DescrStatus) ? "3rem" : "2.4rem"
      //       }
      //       info={infoBySize}
      //     />
      //   );
      // }

      if (info.DescrStatus === "BoxExpired") {
        return (
          <DashInfoCard
            key={index}
            isClickable={isCardClickable(info.DescrStatus)}
            title={getCardTitle(info.DescrStatus)}
            name={info.DescrStatus}
            value={info.QtdStatusBox.count > 0 ? info.QtdStatusBox.count : "-"}
            fontSizeTitle={
              isHighLightCard(info.DescrStatus) ? "1.6rem" : "1.4rem"
            }
            fontWeightTitle={isHighLightCard(info.DescrStatus) ? 600 : 400}
            fontSizeValue={
              isHighLightCard(info.DescrStatus) ? "3rem" : "2.4rem"
            }
            info={infoBySize}
          />
        );
      }

      return (
        <DashInfoCard
          key={index}
          isClickable={isCardClickable(info.DescrStatus)}
          title={getCardTitle(info.DescrStatus)}
          name={info.DescrStatus}
          value={info.QtdStatusBox.count > 0 ? info.QtdStatusBox.count : "-"}
          fontSizeTitle={
            isHighLightCard(info.DescrStatus) ? "1.6rem" : "1.4rem"
          }
          fontWeightTitle={isHighLightCard(info.DescrStatus) ? 600 : 400}
          fontSizeValue={isHighLightCard(info.DescrStatus) ? "3rem" : "2.4rem"}
          info={infoBySize}
        />
      );
    }

    if (isCardToOpenDoors(info.DescrStatus)) {
      openDoorsCard = [...openDoorsCard, info];
    }
    return <div key={index}></div>;
  });

  // const usersCard =
  //   data?.set!.length > 0 && Object.keys(setModulocker).length > 0 ? (

  //   ) : (
  //     <></>
  //   );

  return (
    <>
      <Main>
        {loadingSets ? (
          <Loading />
        ) : (
          <>
            <section id="dashboard-info-boxes">
              <main>
                <Grid container spacing={2}>
                  {infoCards}
                  {setModulocker.users > 0 && (
                    <DashInfoCard
                      name="users"
                      title="Destinatários"
                      value={
                        setModulocker.users > 0 ? setModulocker.users : "-"
                      }
                    />
                  )}
                </Grid>
              </main>
            </section>

            {Object.keys(charts).length > 0 && (
              <>
                <Divider style={{ margin: "40px 0 24px" }} />
                <section id="dashboard-charts">
                  <main style={{ marginBottom: "16px" }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Chart.ColumnDrillDown
                          data={{ ...charts.deliveries, title: "Entregas" }}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Chart.ColumnDrillDown
                          data={{ ...charts.withdrawals, title: "Retiradas" }}
                        />
                      </Grid>
                    </Grid>
                  </main>
                </section>
              </>
            )}
          </>
        )}
      </Main>
    </>
  );
}
